export default function HomeSchemaOrg() {
  const websiteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '久久伊人',
    url: 'https://jiujiuyiren.com',
    description: '久久伊人，专注情感陪伴与品质生活的首选品牌。以真诚与用心守护每一段珍贵关系，让美好情感久久延续。',
    inLanguage: 'zh-CN',
  };

  const webpageJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '久久伊人官方——深情陪伴每一天',
    description: '久久伊人品牌首页，专注情感陪伴与品质生活。探索品牌故事、精选文章与情感生活体验。',
    url: 'https://jiujiuyiren.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '久久伊人',
      url: 'https://jiujiuyiren.com',
    },
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '久久伊人提供哪些服务？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '久久伊人专注于情感陪伴与品质生活领域，提供优质情感生活内容、品牌体验服务以及专业的陪伴建议，涵盖情感陪伴、品质生活、心灵成长和关系经营等多个维度。',
        },
      },
      {
        '@type': 'Question',
        name: '如何联系久久伊人？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过客服热线 400-888-9999（周一至周五 9:00-18:00）或发送邮件至 hello@jiujiuyiren.com 与我们取得联系。您也可以访问久久伊人官网的"关于我们"页面使用在线表单留言。',
        },
      },
      {
        '@type': 'Question',
        name: '久久伊人的品牌理念是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '久久伊人以"深情陪伴每一天"为核心理念，坚持温暖陪伴、情感共鸣和品质体验三大品牌价值，致力于用真诚与用心守护每一段珍贵关系，让美好情感久久延续。',
        },
      },
      {
        '@type': 'Question',
        name: '久久伊人品牌成立多久了？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '久久伊人品牌成立于2014年，已有超过12年的品牌历史。从最初的线下情感咨询工作室，发展成为覆盖情感陪伴、品质生活等多元领域的综合性情感生活品牌，累计服务用户超过50万人。',
        },
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webpageJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
    </>
  );
}